/**
 * Created by 310293471 on 25/03/2018.
 */
export enum contextMenuTypes {
  COLOR_LABEL = 'COLOR_LABEL',
  CUSTOM = 'CUSTOM'
}
